import React, { Component } from "react";
import { Route, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Auth from "./auth";
import AdminAuth from "./admin/auth";
import asyncComponent from "./AsyncComponent";
import PrivateRoute from "./PrivateRoute";
import PrivateAdminRoute from "./PrivateAdminRoute";
import PrivateSuperAdminRoute from "./PrivateSuperAdminRoute";
import {
    getUser,
    checkingLogin,
    checkedLogin,
    checkVersion
} from "../store/WriteClass";

const AsyncAssessment = asyncComponent(() => import("./assessment"));
const AsyncAdmin = asyncComponent(() => import("./admin"));
const AsyncAdminUserCreate = asyncComponent(() =>
    import("./admin/user/create")
);
const AsyncAdminUserList = asyncComponent(() => import("./admin/user/list"));
const AsyncAdminSearch = asyncComponent(() => import("./admin/search"));
const AsyncAdminUserEdit = asyncComponent(() => import("./admin/user/edit"));
const AsyncAdminNeedsReviewList = asyncComponent(() =>
    import("./admin/needsReviewList")
);
const AsyncAdminNeedsReviewDetail = asyncComponent(() =>
    import("./admin/needsReviewDetail")
);
const AsyncAdminSchemaEdit = asyncComponent(() =>
    import("./admin/schema/edit")
);
const AsyncAdminSchemaList = asyncComponent(() => import("./admin/schemaList"));
const AsyncAdminIntegrationsList = asyncComponent(() =>
    import("./admin/integrations")
);
const AsyncAdminExport = asyncComponent(() => import("./admin/export"));

class RouteProvider extends Component {
    async componentDidMount() {
        const { dispatch } = this.props;
        dispatch(checkingLogin());
        try {
            await getUser(dispatch);
        } catch (err) {
            console.error("RouteProvider user request error:", err);
            throw err;
        } finally {
            dispatch(checkedLogin());
        }

        this.route_unlistener = this.props.history.listen(
            (location, action) => {
                dispatch(checkVersion());
            }
        );
    }

    componentWillUnmount() {
        this.route_unlistener(); // stop listening to routes
    }

    render() {
        return (
            <div className="container main">
                <PrivateRoute path="/assessment" component={AsyncAssessment} />
                <PrivateAdminRoute path="/admin" component={AsyncAdmin} />
                <PrivateAdminRoute
                    exact
                    path="/admin/search"
                    component={AsyncAdminSearch}
                />
                <PrivateAdminRoute
                    exact
                    path="/admin/search/:user_id"
                    component={AsyncAdminSearch}
                />
                <PrivateAdminRoute
                    exact
                    path="/admin/needsreview"
                    component={AsyncAdminNeedsReviewList}
                />
                <PrivateAdminRoute
                    exact
                    path="/admin/needsreview/:user_id"
                    component={AsyncAdminNeedsReviewDetail}
                />
                <PrivateAdminRoute
                    exact
                    path="/admin/export"
                    component={AsyncAdminExport}
                />
                <PrivateSuperAdminRoute
                    exact
                    path="/admin/user/create"
                    component={AsyncAdminUserCreate}
                />
                <PrivateSuperAdminRoute
                    exact
                    path="/admin/user/list"
                    component={AsyncAdminUserList}
                />
                <PrivateSuperAdminRoute
                    exact
                    path="/admin/schema/edit/:schema_id"
                    component={AsyncAdminSchemaEdit}
                />
                <PrivateSuperAdminRoute
                    exact
                    path="/admin/schemas/list"
                    component={AsyncAdminSchemaList}
                />
                <PrivateSuperAdminRoute
                    exact
                    path="/admin/integrations"
                    component={AsyncAdminIntegrationsList}
                />
                <PrivateAdminRoute
                    exact
                    path="/admin/user/edit"
                    component={AsyncAdminUserEdit}
                />
                <Route exact path="/adminlogin" component={AdminAuth} />
                <Route exact path="/" component={Auth} />
            </div>
        );
    }
}

export default withRouter(connect()(RouteProvider));



// WEBPACK FOOTER //
// ./src/components/RouteProvider.js